import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Delivery, DeliveryStatus, DeliveryStatusAux } from 'src/app/models/delivery.schema';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import { formatCurrency, formatDate, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
registerLocaleData(localeIt, 'it');

@Component({
  selector: 'app-finance-margin',
  templateUrl: './finance-margin.component.html',
  styleUrls: ['./finance-margin.component.scss']
})
export class FinanceMarginComponent implements OnInit {

  isSuperAdmin: boolean = false;
  financeFeesFilterForm: any;
  deliveryStatus = DeliveryStatus;
  deliveryStatusAux = DeliveryStatusAux;
  order: {};
  limit: number;
  page: number;
  count: number;
  maxPage: number;
  defaultPage = 1;
  defaultLimit = 100;
  defaultOrder = { 'Delivery.deliveryDate': 'DESC', 'Delivery.fromTime': 'ASC', 'Delivery.toTime': 'ASC' };
  filtered = {};
  today: any;
  deliveries: Delivery[] = [];
  groups: any;
  flattenedDeliveries: any[] = [];
  filteredDeliveries: Delivery[] = [];
  totalValues = {
    totalValoreVendite: 0,
    totalPrezzoPubblico: 0,
    totalConsegnaPrezzo: 0,
    totalFeePercentage: 0,
    totalFeeValue: 0,
    totalFeeValueWithIva: 0,
    totalDeliveryCost: 0,
    totalIva: 0,
    totalPartnerCollectionPrice: 0,
    totalPrimoMargine: 0,
    totalCorrispettivo: 0,
    totalMargineTotale: 0,
    totalPrimoMarginePercentage: 0,
    totalPrezzoPartner: 0,
    totalNettaSenzIva: 0,
    totalCommissioneIncassi: 0,
    totalPartnerPrice: 0,
    totalPartnerAdditionalPrice: 0,
    totalExpertPrice: 0,
    totalExpertAdditionalPrice: 0,
    totalMarginePercentage: 0,
  };

  filters = {
    margineTotale: { operator: '=', value: '' },
    margineTotalePercentage: { operator: '=', value: '' },
  };

  constructor(
    private commanUsesService: CommanUsesService,
    private deliveryService: DeliveryService,
    private route: ActivatedRoute,
    private authStatusService: AuthStatusService,
    private spinnerService: SpinnerService,
    private router: Router,
  ) { 
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
  }

  async ngOnInit() {
    try {
      var today = new Date();
      var tmptoday = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2); //DATA CORRENTE
      this.today = tmptoday;
      this.manageFinanceFeesFilterForm();
      await this.filter();
    } catch (error) {
      this.commanUsesService.showSnackBar(`ERROR_${error?.message || 'UNKNOWN_ERROR'}`);
      this.spinnerService.hide();
    }
  }

  manageFinanceFeesFilterForm(){
    this.financeFeesFilterForm = new FormGroup({
      'Delivery.id': new FormControl(''),
      'Delivery.deliveryDate_from': new FormControl(this.today),
      'Delivery.deliveryDate_to': new FormControl(this.today),
      'Delivery.fromTime': new FormControl(''),
      'Delivery.toTime': new FormControl(''),
      'Partner.businessName': new FormControl(''),
      'UserExpert.surname': new FormControl(''),
      'Delivery.status': new FormControl(''),
      'Delivery.address': new FormControl(''),
      'Delivery.serviceType': new FormControl(''),
      'Delivery.billable': new FormControl(''),
      'Delivery.payable': new FormControl(''),
      'Delivery.pickUpAddress': new FormControl(''),
      'Delivery.ddtNumber': new FormControl(''),
      'Delivery.pickUpTime': new FormControl(''),
      'Delivery.price': new FormControl(''),
      'Delivery.price.operator': new FormControl('equal'),
      'Delivery.additionalPrice': new FormControl(''),
      'Delivery.additionalPrice.operator': new FormControl('equal'),
      'Delivery.expertSalary': new FormControl(''),
      'Delivery.expertSalary.operator': new FormControl('equal'),
      'Delivery.valetAdditionalPrice': new FormControl(''),
      'Delivery.valetAdditionalPrice.operator': new FormControl('equal'),
      'Sale.platform': new FormControl(''),
    })
  }

  async resetFilter() {
    this.financeFeesFilterForm = new FormGroup({
      'Delivery.id': new FormControl(''),
      'Delivery.deliveryDate_from': new FormControl(),
      'Delivery.deliveryDate_to': new FormControl(),
      'Delivery.fromTime': new FormControl(''),
      'Delivery.toTime': new FormControl(''),
      'Partner.businessName': new FormControl(''),
      'UserExpert.surname': new FormControl(''),
      'Delivery.status': new FormControl(''),
      'Delivery.address': new FormControl(''),
      'Delivery.serviceType': new FormControl(''),
      'Delivery.billable': new FormControl(''),
      'Delivery.payable': new FormControl(''),
      'Delivery.pickUpAddress': new FormControl(''),
      'Delivery.ddtNumber': new FormControl(''),
      'Delivery.pickUpTime': new FormControl(''),
      'Delivery.price': new FormControl(''),
      'Delivery.price.operator': new FormControl('equal'),
      'Delivery.additionalPrice': new FormControl(''),
      'Delivery.additionalPrice.operator': new FormControl('equal'),
      'Delivery.expertSalary': new FormControl(''),
      'Delivery.expertSalary.operator': new FormControl('equal'),
      'Delivery.valetAdditionalPrice': new FormControl(''),
      'Delivery.valetAdditionalPrice.operator': new FormControl('equal'),
      'Sale.platform': new FormControl(''),
    });
    await this.filter();
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }

  public async navigateOrder(attribute: string | string[]) {
    delete this.order['Delivery.updatedAt'];
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async (data) => {
      await this.loadDeliveries();
    });
  }

  navigate(event) {
    this.loadDeliveries(event.limit, event.page, this.order);
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

  async filter() {
    let filterForm = (new FormGroupToObject()).transform(this.financeFeesFilterForm);
    this.filtered = {};

    if (filterForm['Delivery.id'])
      this.filtered['Delivery.id'] = filterForm['Delivery.id'];
    if (filterForm['Delivery.deliveryDate_from'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.deliveryDate_from']] };
    if (filterForm['Delivery.deliveryDate_to'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'lessThan', values: [filterForm['Delivery.deliveryDate_to']] };
    if (filterForm['Delivery.deliveryDate_from'] && filterForm['Delivery.deliveryDate_to'])
      this.filtered['Delivery.deliveryDate'] = { operator: 'between', values: [filterForm['Delivery.deliveryDate_from'], filterForm['Delivery.deliveryDate_to']] };
    if (filterForm['Delivery.fromTime'])
      this.filtered['Delivery.fromTime'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.fromTime']] };
    if (filterForm['Delivery.toTime'])
      this.filtered['Delivery.toTime'] = { operator: 'lessThan', values: [filterForm['Delivery.toTime']] };
    if (filterForm['Partner.businessName'])
      this.filtered['Partner.businessName'] = { operator: 'like', values: [`%${filterForm['Partner.businessName']}%`] };
    if (filterForm['UserExpert.surname'])
      this.filtered['UserExpert.surname'] = { operator: 'like', values: [`%${filterForm['UserExpert.surname']}%`], concat: [{ string: ' ' }, { column: 'UserExpert.name' }] };
    if (filterForm['Delivery.pickUpAddress'])
      this.filtered['Delivery.pickUpAddress'] = { operator: 'like', values: [`%${filterForm['Delivery.pickUpAddress']}%`], concat: [{ string: ' ' }, { column: 'Delivery.partner.address' }] };
    if (filterForm['Delivery.pickUpTime'])
      this.filtered['Delivery.pickUpTime'] = { operator: 'moreThanOrEqual', values: [filterForm['Delivery.pickUpTime']] };
    if (filterForm['Delivery.status'])
      this.filtered['Delivery.status'] = filterForm['Delivery.status'];
    if (filterForm['Delivery.address'])
      this.filtered['Delivery.address'] = { operator: 'like', values: [`%${filterForm['Delivery.address']}%`]};
    if (filterForm['Delivery.serviceType'])
      this.filtered['Delivery.serviceType'] = { operator: 'like', values: [`%${filterForm['Delivery.serviceType']}%`]};
    if (filterForm['Delivery.billable'])
      this.filtered['Delivery.billable'] = { operator: 'like', values: [`%${filterForm['Delivery.billable']}%`]};
    if (filterForm['Delivery.payable'])
      this.filtered['Delivery.payable'] = { operator: 'like', values: [`%${filterForm['Delivery.payable']}%`]};

    if (filterForm['Delivery.ddtNumber']) {
      this.filtered['Delivery.ddtNumber'] = {
        operator: 'like',
        values: [`%${filterForm['Delivery.ddtNumber']}%`]
      };
    }

    if (filterForm['Delivery.price'])
      this.filtered['Delivery.price'] = { operator: filterForm['Delivery.price.operator'], values: [filterForm['Delivery.price']] };

    if (filterForm['Delivery.additionalPrice'])
      this.filtered['Delivery.additionalPrice'] = { operator: filterForm['Delivery.additionalPrice.operator'], values: [filterForm['Delivery.additionalPrice']] };

    if (filterForm['Delivery.expertSalary'])
      this.filtered['Delivery.expertSalary'] = { operator: filterForm['Delivery.expertSalary.operator'], values: [filterForm['Delivery.expertSalary']] };

    if (filterForm['Delivery.valetAdditionalPrice'])
      this.filtered['Delivery.valetAdditionalPrice'] = { operator: filterForm['Delivery.valetAdditionalPrice.operator'], values: [filterForm['Delivery.valetAdditionalPrice']] };

    if (filterForm['Sale.platform'])
      this.filtered['Sale.platform'] = { operator: 'like', values: filterForm['Sale.platform']};

    await this.loadDeliveries();
  }

  async loadDeliveries(limit?: number, page?: number, order?: {}) {

    let filterForm = (new FormGroupToObject()).transform(this.financeFeesFilterForm);
    if(filterForm['Delivery.deliveryDate_to'] && filterForm['Delivery.deliveryDate_from']){
      if((this.today != filterForm['Delivery.deliveryDate_from'])){
        this.defaultOrder = { 'Delivery.deliveryDate': 'ASC', 'Delivery.fromTime': 'ASC', 'Delivery.toTime': 'ASC' };
      }
    }
    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;

    this.spinnerService.show();
    let deliveries = await this.deliveryService.getAllFinanceMargin(this.page, this.limit, this.order, this.filtered);
    this.deliveries = deliveries.deliveries;
    this.count = deliveries.count;
    this.flattenDeliveries();
    this.generateTotals();
    this.maxPage = Math.ceil(this.count / this.limit);
    this.spinnerService.hide();
  }

  applyDomFilters() {
    this.filteredDeliveries = this.deliveries.filter(delivery => {
      const computed = this.commanFunctionForValues(delivery);

      return this.compare(computed.margineTotale, this.filters.margineTotale) &&
             this.compare(computed.margineTotalePercentage, this.filters.margineTotalePercentage)
    });
  
    this.flattenedDeliveries = this.flattenFilteredDeliveries(this.filteredDeliveries);
    this.generateTotals(this.filteredDeliveries);
  }

  compare(value: any, filter: { operator: string, value: any }): boolean {
    if (!filter.value && filter.value !== 0) return true;
  
    const target = parseFloat(filter.value);
    const val = parseFloat(value);
  
    switch (filter.operator) {
      case '=': return val === target;
      case '>': return val > target;
      case '<': return val < target;
      case '>=': return val >= target;
      case '<=': return val <= target;
      default: return true;
    }
  }

  flattenDeliveries() {

    this.flattenedDeliveries = [];
    const grouped = new Map<number | string, any[]>();

    for (const delivery of this.deliveries) {
      if (delivery.serviceType === 'sales') {
        /*
        const key = delivery.ddtNumber ?? 'unknown';
        if (!grouped.has(key)) {
          grouped.set(key, []);
        }
        grouped.get(key)!.push(delivery);
        */

        let raw = delivery.ddtNumber?.toString() ?? "";

        if (/^[DCFB]/i.test(raw)) {
          raw = raw.substring(1);
        }

        const key = raw.replace(/\D/g, ""); 

        if (!grouped.has(key)) {
          grouped.set(key, []);
        }
        grouped.get(key)!.push(delivery);
      } else {
        this.flattenedDeliveries.push(delivery);
      }
    }

    this.flattenedDeliveries = this.flattenedDeliveries || [];

    for (const [key, group] of grouped) {
      if (group.length > 1) {
        const totalRow = {
          ...group[0],
          isTotalRow: true,
          deliveryCount: group.length,
        };
        this.flattenedDeliveries.push(totalRow);
      }

      this.flattenedDeliveries.push(...group);
    }
  }

  flattenFilteredDeliveries(deliveries: Delivery[]) {
    const grouped = new Map<number | string, any[]>();
    const result: any[] = [];

    for (const delivery of deliveries) {
      if (delivery.serviceType === 'sales') {
        /*
        const key = delivery.ddtNumber ?? 'unknown';
        if (!grouped.has(key)) {
          grouped.set(key, []);
        }
        grouped.get(key)!.push(delivery);
        */

        let raw = delivery.ddtNumber?.toString() ?? "";

        if (/^[DCFB]/i.test(raw)) {
          raw = raw.substring(1);
        }

        const key = raw.replace(/\D/g, ""); 

        if (!grouped.has(key)) {
          grouped.set(key, []);
        }
        grouped.get(key)!.push(delivery);
      } else {
        result.push(delivery);
      }
    }

    for (const [key, group] of grouped) {
      if (group.length > 1) {
        const totalRow = {
          ...group[0],
          isTotalRow: true,
          deliveryCount: group.length,
        };
        result.push(totalRow);
      }

      result.push(...group);
    }

    return result;
  }


  showServiceDetails(incomingDelivery: any){
    let data = this.deliveries.find((delivery) => incomingDelivery.id == delivery.id);
    let service = data?.partner?.partnerServices.find((item) => item?.service?.id == incomingDelivery.service);
    return service;
  }

  getDeliveryLink(id: number, deluxyDelivery: boolean): any[] {
    let route = ['/consegne', id];
    if (this.groups.includes('admin')){
        route.push('edit');
    }
    return route;
  }

  formatTimeShow(fromTime, toTime){
    let trimmedFromTime = fromTime != null ? fromTime?.slice(0, -3) : '';
    let trimmedToTime = toTime != null ? toTime?.slice(0, -3) : '';
    let time = trimmedFromTime + '-' + trimmedToTime;
    return time;
  }

  commanFunctionForValues(delivery: Delivery) {
    let service = delivery?.partner?.partnerServices?.find(
      (service) => service?.service?.id == delivery?.service
    );

    let IS_SALE_TYPE = service?.service?.pricingModel?.toLowerCase() === 'sales';
    let IS_FIXEDPRICE_TYPE = service?.service?.pricingModel?.toLowerCase() === 'fixedprice';
    let IS_HOURLYRATE_TYPE = service?.service?.pricingModel?.toLowerCase() === 'hourlyrate';

    let deliveryProducts       = delivery?.deliveryProducts || [];
    let feePercentageValue     = Number(service?.price) || 0;
    let feeValue               = 0;
    let totalPartnerPrice      = 0;
    let prezzoPartner          = 0;
    let vatPercentage          = 0.22;
    let feePercentage          = 0.03;

    if (deliveryProducts.length > 0) {
      deliveryProducts.forEach((product, index) => {
        const quantity = Number(product?.quantity) || 1;
        let productPrice = 0;

        if(delivery?.isFlexiblePrice) {
          let data = delivery?.flexiblePrice ? JSON.parse(delivery?.flexiblePrice) : [];
          data = data[index];
          productPrice = data?.product?.flexiblePrice || 0;
        } else {
          if (product?.productVariant) {
            productPrice = Number(product?.productVariant?.variantPrice) || 0;
          } else {
            productPrice = Number(product?.product?.price) || 0;
          }
        }
    
        const productSubtotal = productPrice * quantity;
    
        prezzoPartner     += productSubtotal;
        feeValue          += productSubtotal * (feePercentageValue / 100);
        totalPartnerPrice += productSubtotal;
      });
    }

    
    if(!delivery.billable) {
      prezzoPartner = 0;
      feeValue = 0;
      totalPartnerPrice = 0;
    } 
    
    // let valoreVendite          = Number(delivery?.shopifySale?.totalPrice) || 0;
    let valoreVendite          = 0;
    if (delivery?.shopifySale?.totalPrice != null && delivery?.shopifySale?.totalPrice > 0) {
      valoreVendite = Number(delivery.shopifySale.totalPrice);
    } else if (delivery?.shopifySale?.total != null) {
      valoreVendite = Number(delivery.shopifySale.total);
    }
    let feeValueWithIva        = feeValue + (feeValue * vatPercentage);
    let partnerCollectionPrice = totalPartnerPrice - feeValueWithIva;
    let expertSalary           = delivery?.payable ? Number(delivery?.expertSalary) : 0 || 0;
    let valetAdditionalPrice   = delivery?.payable ? Number(delivery?.valetAdditionalPrice) : 0 || 0;
    let totalDeliveryCost      = expertSalary + valetAdditionalPrice;
    let totalLineItemsPrice    = Number(delivery?.shopifySale?.totalLineItemsPrice) || 0;
    let primoMargine           = (valoreVendite - prezzoPartner) / (1+vatPercentage) + feeValue;
    let primoMarginePercentage = valoreVendite > 0 ? (primoMargine / valoreVendite) * 100 : 0;
    let prezzoPubblico         = totalLineItemsPrice;
    let consegnaPrezzo         = this.showDeliveryPrice(delivery) || 0;
    let partnerName            = delivery?.partner?.businessName || '---';
    let corrispettivo          = Number(valoreVendite) - Number(prezzoPartner) || 0;
    let iva                    = vatPercentage * (corrispettivo === 0 ? 1 : corrispettivo);
    let commissioneIncassi     = valoreVendite * feePercentage || 0;
    let margineTotale          = Number(primoMargine) - Number(commissioneIncassi) - Number(totalDeliveryCost) || 0;
    let margineTotalePercentage= valoreVendite > 0 ? (margineTotale / valoreVendite) * 100 : 0;
    let nettaSenzIva           = (primoMargine / valoreVendite) * 100;
    let partnerPrice           = delivery?.billable || delivery?.payable ? Number(delivery?.price) || 0 : 0;
    let partnerAdditionalPrice = delivery?.billable || delivery?.payable ? Number(delivery?.additionalPrice) || 0 : 0;
    let expertPrice            = delivery?.billable || delivery?.payable ? Number(delivery?.expertSalary) || 0 : 0;
    let expertAdditionalPrice  = delivery?.billable || delivery?.payable ? Number(delivery?.valetAdditionalPrice) || 0 : 0;

    if(IS_FIXEDPRICE_TYPE || IS_HOURLYRATE_TYPE) {
      margineTotale            = Number((partnerPrice + partnerAdditionalPrice) - (expertPrice + expertAdditionalPrice));
      margineTotalePercentage  = Number((margineTotale / (partnerPrice + partnerAdditionalPrice) * 100));
    }
 
    let multipleDeliveriesWithSameDdtNumber = (this.filteredDeliveries?.length > 0 ? this.filteredDeliveries : this.deliveries).filter((item) => item?.ddtNumber == delivery?.ddtNumber && item?.serviceType ==='sales');

    return {
      valoreVendite,
      prezzoPubblico,
      consegnaPrezzo,
      partnerName,
      feePercentage: feePercentageValue,
      feeValue: feeValue.toFixed(2),
      feeValueWithIva: feeValueWithIva.toFixed(2),
      totalDeliveryCost,
      iva: iva.toFixed(2),
      partnerCollectionPrice: partnerCollectionPrice.toFixed(2),
      primoMargine: primoMargine.toFixed(2),
      corrispettivo: corrispettivo.toFixed(2),
      margineTotale: margineTotale.toFixed(2),
      primoMarginePercentage: primoMarginePercentage.toFixed(2),
      prezzoPartner: prezzoPartner.toFixed(2),
      nettaSenzIva: nettaSenzIva.toFixed(2),
      margineTotalePercentage: margineTotalePercentage.toFixed(2),
      commissioneIncassi: commissioneIncassi.toFixed(2),
      isMultiple: multipleDeliveriesWithSameDdtNumber.length > 1 ? true : false,
      partnerPrice: partnerPrice.toFixed(2),
      partnerAdditionalPrice: partnerAdditionalPrice.toFixed(2),
      expertPrice: expertPrice.toFixed(2),
      expertAdditionalPrice: expertAdditionalPrice.toFixed(2),
    };
  }

  showDeliveryPrice(delivery: Delivery) {

    if(delivery?.shopifySale?.totalShippingAmount && delivery?.shopifySale?.totalShippingAmount > 0) {
      return Number(delivery?.shopifySale?.totalShippingAmount) || 0;
    }
    if(delivery?.shopifySale?.totalShippingPriceSet){
      let shippingPriceSet = JSON.parse(delivery?.shopifySale?.totalShippingPriceSet);
      return Number(shippingPriceSet?.shop_money?.amount) || 0;
    }
    return 0;
  }

  generateTotals(deliveriesList: Delivery[] = this.deliveries) {
    this.totalValues = {
      totalValoreVendite: 0,
      totalPrezzoPubblico: 0,
      totalConsegnaPrezzo: 0,
      totalFeePercentage: 0,
      totalFeeValue: 0,
      totalFeeValueWithIva: 0,
      totalDeliveryCost: 0,
      totalIva: 0,
      totalPartnerCollectionPrice: 0,
      totalPrimoMargine: 0,
      totalCorrispettivo: 0,
      totalMargineTotale: 0,
      totalPrimoMarginePercentage: 0,
      totalPrezzoPartner: 0,
      totalNettaSenzIva: 0,
      totalCommissioneIncassi: 0,
      totalPartnerPrice: 0,
      totalPartnerAdditionalPrice: 0,
      totalExpertPrice: 0,
      totalExpertAdditionalPrice: 0,
      totalMarginePercentage: 0,
    };

    const groupedByDdt: { [ddt: string]: Delivery[] } = {};

    // Group only service-type deliveries by ddtNumber
    deliveriesList.forEach(delivery => {
      if (delivery?.serviceType === 'sales') {
        if (!groupedByDdt[delivery.ddtNumber]) {
          groupedByDdt[delivery.ddtNumber] = [];
        }
        groupedByDdt[delivery.ddtNumber].push(delivery);
      } else {
        // Treat non-service delivery as its own "group"
        groupedByDdt[`non_service_${delivery.id}`] = [delivery];
      }
    });

    // Iterate over all groups (real DDT groups and individual non-service deliveries)
    for (const ddt in groupedByDdt) {
      const group = groupedByDdt[ddt];

      if (group.length > 1 && group[0]?.serviceType === 'sales') {
        const dummyTotalRow = { ...group[0], isTotalRow: true };
        const totals = this.showTotalOfParentRow(dummyTotalRow);

        this.totalValues.totalValoreVendite          += totals.parentValoreVendite;
        this.totalValues.totalPrezzoPubblico         += totals.parentPrezzoPubblico;
        this.totalValues.totalConsegnaPrezzo         += totals.parentConsegnaPrezzo;
        this.totalValues.totalFeePercentage          += totals.parentFeePercentage;
        this.totalValues.totalFeeValue               += totals.parentFeeValue;
        this.totalValues.totalFeeValueWithIva        += totals.parentFeeValueWithIva;
        this.totalValues.totalDeliveryCost           += totals.parentDeliveryCost;
        this.totalValues.totalIva                    += totals.parentIva;
        this.totalValues.totalPartnerCollectionPrice += totals.parentPartnerCollectionPrice;
        this.totalValues.totalPrimoMargine           += totals.parentPrimoMargine;
        this.totalValues.totalCorrispettivo          += totals.parentCorrispettivo;
        this.totalValues.totalMargineTotale          += totals.parentMargineTotale;
        this.totalValues.totalPrimoMarginePercentage += totals.parentPrimoMarginePercentage;
        this.totalValues.totalPrezzoPartner          += totals.parentPrezzoPartner;
        this.totalValues.totalNettaSenzIva           += totals.parentNettaSenzIva;
        this.totalValues.totalCommissioneIncassi     += totals.parentCommissioneIncassi;
        this.totalValues.totalPartnerPrice           += Number(totals?.parentPartnerPrice) || 0;
        this.totalValues.totalPartnerAdditionalPrice += Number(totals?.parentPartnerAdditionalPrice) || 0;
        this.totalValues.totalExpertPrice            += Number(totals?.parentExpertPrice) || 0;
        this.totalValues.totalExpertAdditionalPrice  += Number(totals?.parentExpertAdditionalPrice) || 0;

      } else {
        const delivery = group[0];
        const values = this.commanFunctionForValues(delivery);

        this.totalValues.totalValoreVendite          += Number(values?.valoreVendite) || 0;
        this.totalValues.totalPrezzoPubblico         += Number(values?.prezzoPubblico) || 0;
        this.totalValues.totalConsegnaPrezzo         += Number(values?.consegnaPrezzo) || 0;
        this.totalValues.totalFeePercentage          += Number(values?.feePercentage) || 0;
        this.totalValues.totalFeeValue               += Number(values?.feeValue) || 0;
        this.totalValues.totalFeeValueWithIva        += Number(values?.feeValueWithIva) || 0;
        this.totalValues.totalDeliveryCost           += Number(delivery?.expertSalary) + Number(delivery?.valetAdditionalPrice) || 0;
        this.totalValues.totalIva                    += Number(values?.iva) || 0;
        this.totalValues.totalPartnerCollectionPrice += Number(values?.partnerCollectionPrice) || 0;
        this.totalValues.totalPrimoMargine           += Number(values?.primoMargine) || 0;
        this.totalValues.totalCorrispettivo          += Number(values?.corrispettivo) || 0;
        this.totalValues.totalMargineTotale          += Number(values?.margineTotale) || 0;
        this.totalValues.totalPrimoMarginePercentage += Number(values?.primoMarginePercentage) || 0;
        this.totalValues.totalPrezzoPartner          += Number(values?.prezzoPartner) || 0;
        this.totalValues.totalNettaSenzIva           += Number(values?.nettaSenzIva) || 0;
        this.totalValues.totalCommissioneIncassi     += Number(values?.commissioneIncassi) || 0;
        this.totalValues.totalPartnerPrice           += Number(values?.partnerPrice) || 0;
        this.totalValues.totalPartnerAdditionalPrice += Number(values?.partnerAdditionalPrice) || 0;
        this.totalValues.totalExpertPrice            += Number(values?.expertPrice) || 0;
        this.totalValues.totalExpertAdditionalPrice  += Number(values?.expertAdditionalPrice) || 0;
      }
    }

    this.totalValues.totalMarginePercentage = Number((Number(this.totalValues?.totalMargineTotale) / Number(this.totalValues.totalPartnerPrice)) * 100);
    // console.log("this.totalValues.totalMargineTotale", this.totalValues.totalMargineTotale);
  }

  showTotalOfParentRow(delivery: any) {

    let totals = {

      parentValoreVendite: 0,
      parentPrezzoPubblico: 0,
      parentConsegnaPrezzo: 0,
      parentFeePercentage: 0,
      parentFeeValue: 0,
      parentFeeValueWithIva: 0,
      parentDeliveryCost: 0,
      parentIva: 0,
      parentPartnerCollectionPrice: 0,
      parentPrimoMargine: 0,
      parentCorrispettivo: 0,
      parentMargineparente: 0,
      parentPrimoMarginePercentage: 0,
      parentPrezzoPartner: 0,
      parentNettaSenzIva: 0,
      parentCommissioneIncassi: 0,
      parentMargineTotale: 0,
      parentMargineTotalePercentage: 0,
      parentPartnerPrice: 0,
      parentPartnerAdditionalPrice: 0,
      parentExpertPrice: 0,
      parentExpertAdditionalPrice: 0,
    }

    if(delivery?.isTotalRow){
      let deliveries = (this.filteredDeliveries?.length > 0 ? this.filteredDeliveries : this.deliveries).filter((item) => item?.ddtNumber == delivery?.ddtNumber);

      deliveries.forEach((item) => {
        let values                          = this.commanFunctionForValues(item);
        totals.parentValoreVendite          = Number((Number(values?.valoreVendite) || 0).toFixed(2));
        totals.parentPrezzoPubblico         = Number((Number(values?.prezzoPubblico) || 0).toFixed(2));
        totals.parentConsegnaPrezzo         = Number((Number(values?.consegnaPrezzo) || 0).toFixed(2));
        totals.parentFeeValue               = Number((totals.parentFeeValue + Number(values?.feeValue) || 0).toFixed(2));
        totals.parentFeeValueWithIva        = Number((totals.parentFeeValueWithIva + Number(values?.feeValueWithIva) || 0).toFixed(2));
        
        let feePercentage                   = (totals.parentFeeValue / totals.parentPrezzoPubblico) * 100;
        totals.parentFeePercentage          = Number((feePercentage || 0).toFixed(2));
        totals.parentDeliveryCost           = Number((totals.parentDeliveryCost + Number(values?.totalDeliveryCost) || 0).toFixed(2));
        totals.parentMargineparente         = Number((totals.parentMargineparente + Number(values?.margineTotale) || 0).toFixed(2));
        totals.parentPrezzoPartner          = Number((totals.parentPrezzoPartner + Number(values?.prezzoPartner) || 0).toFixed(2));
        let primoMargin                     = (Number(totals.parentValoreVendite) - Number(totals.parentPrezzoPartner)) / 1.22 + totals.parentFeeValue;
        totals.parentPrimoMargine           = Number((primoMargin || 0).toFixed(2));
        totals.parentPrimoMarginePercentage = Number((totals.parentPrimoMargine / Number(totals.parentValoreVendite) * 100 || 0).toFixed(2));
        totals.parentCorrispettivo          = Number((totals.parentValoreVendite - Number(totals?.parentPrezzoPartner)).toFixed(2));
        totals.parentIva                    = Number(Number((totals.parentCorrispettivo * 0.22)).toFixed(2));
        totals.parentNettaSenzIva           = Number((totals.parentNettaSenzIva + Number(values?.nettaSenzIva) || 0).toFixed(2));
        totals.parentCommissioneIncassi     = Number((totals.parentValoreVendite * 0.03).toFixed(2));
        // totals.parentMargineTotale          = Number((totals.parentPrimoMargine - Number(totals?.parentIva) - Number(totals.parentCommissioneIncassi) - (totals.parentDeliveryCost) || 0).toFixed(2));
        totals.parentMargineTotale          = Number((totals.parentPrimoMargine - Number(totals.parentCommissioneIncassi) - (totals.parentDeliveryCost) || 0).toFixed(2));
        totals.parentMargineTotalePercentage= Number((totals.parentMargineTotale / Number(totals?.parentValoreVendite) * 100 || 0).toFixed(2));
        totals.parentPartnerCollectionPrice = Number((totals.parentPartnerCollectionPrice + Number(values?.partnerCollectionPrice) || 0).toFixed(2));
        totals.parentPartnerPrice           = Number((totals.parentPartnerPrice + Number(values?.partnerPrice) || 0).toFixed(2));
        totals.parentPartnerAdditionalPrice = Number((totals.parentPartnerAdditionalPrice + Number(values?.partnerAdditionalPrice) || 0).toFixed(2));
        totals.parentExpertPrice            = Number((totals.parentExpertPrice + Number(values?.expertPrice) || 0).toFixed(2));
        totals.parentExpertAdditionalPrice  = Number((totals.parentExpertAdditionalPrice + Number(values?.expertAdditionalPrice) || 0).toFixed(2));
      });
    }

    return totals;
  }

  exportFinanceMarginReport() {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Finance Report');

    const headers = [
      'STATO',
      'ID VENDITA',
      'ID CONSEGNE',
      'DATA CONSEGNA', 
      'ORARIO', 
      'PARTNER',
      'VALET',
      'INDIRIZZO',
      'INDIRIZZO DI RITIRO',
      'ORA RITIRO',
      'TIPO SERVIZIO',
      'DA FATTURARE',
      'DA PAGARE',
      'PREZZO',
      '+/- PREZZO',
      'VALET SALARIO',
      '+/- PREZZO STIPENDI',
      'PRIMO MARGINE', 
      'PRIMO MARGINE %'
    ];

    worksheet.addRow(headers).eachCell((cell) => {
      cell.font = { bold: true };
    });

    for (const delivery of this.flattenedDeliveries) {

      let service = delivery?.partner?.partnerServices?.find((service) => service?.service?.id == delivery?.service);
      let IS_HOURLYRATE_TYPE = service?.service?.pricingModel?.toLowerCase() === 'hourlyrate';

      const euro = (value: number) => formatCurrency(value || 0, 'it', '€', 'EUR', '1.2-2');
      const formatDateIt = (date: any) => formatDate(date, 'fullDate', 'it');
      const values = this.commanFunctionForValues(delivery);
      const parentValues = this.showTotalOfParentRow(delivery);

      const ORARIO = 
        delivery?.service && !IS_HOURLYRATE_TYPE 
        ? this.formatTimeShow(delivery.fromTime, delivery.toTime) 
        : delivery?.service && IS_HOURLYRATE_TYPE
        ? this.formatTimeShow(delivery.startTime, delivery.endTime)
        : !delivery?.service 
        ? this.formatTimeShow(delivery.fromTime, delivery.toTime)
        : '';

      let valetName = '';
      valetName = delivery?.expert
        ? `${delivery.expert?.user?.surname || '---'} ${delivery.expert?.user?.name || '---'}`
        : '---';

      const isTotal = delivery.isTotalRow;
      const isGrouped = values?.isMultiple;
      const margin = Number(values?.margineTotale);

      const rowData = [
        (delivery.status || '').toUpperCase(),
        delivery.ddtNumber ? Number(delivery.ddtNumber) : '---',
        Number(delivery.id),
        formatDateIt(delivery.deliveryDate),
        ORARIO,
        delivery.partner?.businessName || '---',
        valetName,
        delivery.address || '---',
        delivery.pickUpAddress || '---',
        delivery?.pickUpTime || '---',
        delivery?.serviceType?.toUpperCase() || '---',
        delivery?.billable ? "Si" : "No",
        delivery?.payable ? "Si" : "No",
        euro(Number(isTotal ? parentValues.parentPartnerPrice : values?.partnerPrice ?? 0)),
        euro(Number(isTotal ? parentValues.parentPartnerAdditionalPrice : values?.partnerAdditionalPrice ?? 0)),
        euro(Number(isTotal ? parentValues.parentExpertPrice : values?.expertPrice ?? 0)),
        euro(Number(isTotal ? parentValues.parentExpertAdditionalPrice : values?.expertAdditionalPrice ?? 0)),
        euro(Number(isTotal ? parentValues.parentMargineTotale : values?.margineTotale ?? 0)),
        Number(isTotal ? parentValues.parentMargineTotalePercentage : values?.margineTotalePercentage ?? 0) + '%',
      ];

      const row = worksheet.addRow(rowData);

      let bgColor = null;

      if (margin <= 0) {
        bgColor = 'FFFFCCCC'; // light red background
      } else if (isTotal) {
        bgColor = 'FFd0ebff'; // dark blue
      } else if (isGrouped) {
        bgColor = 'FFe7f5ff'; // light blue
      }

      if (bgColor) {
        row.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: bgColor },
          };
          if (margin <= 0) {
            cell.font = { color: { argb: 'FF000000' }, bold: true }; // black bold text for red rows
          }
        });
      }
    }

    // Auto column widths
    worksheet.columns.forEach((col) => {
      let maxLength = 10;
      col.eachCell({ includeEmpty: true }, (cell) => {
        const value = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, value.length);
      });
      col.width = maxLength + 2;
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      FileSaver.saveAs(blob, 'margini.xlsx');
    });
  }

}
